import { SERVICE_URL } from './ServiceURL'

class UtilsService {

	constructor (resource) {
		this.store = resource.$store;
		this.http = resource.$http;

		this.baseURL = SERVICE_URL
	}

	getOverview () {
		return this.http.get(`${this.baseURL}v1/projetos/overview`, null)
			.then(response => response.json())
	}

	getPabx(pabx) {
		return new Promise((resolve, reject) => {
			this.http.get(`${this.baseURL}v1/pabx`, { params: { pabx: pabx } })
				.then(response => response.json())
				.then(result => resolve(result))
				.catch(err => reject(err.message || err))
		})
	}

	fetchCEP (cep) {
		return new Promise((resolve, reject) => {
			this.http.get(`${this.baseURL}v1/correios/cep/${cep}`, {
				headers: {
					'x-access-token': this.store.state.user.token || ''
				}
			})
				.then(response => response.json())
				.then(result => resolve(result))
				.catch(err => {
					reject(err.message || err);
				});
		})
	}
}

export default UtilsService



// WEBPACK FOOTER //
// ./src/service/UtilsService.js